import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { Box, Typography, Icon, Link, Button } from '@material-ui/core';
import { useHistory } from 'react-router-dom';

import useStyles from './styles';

const SendSuccess = () => {
  const classes = useStyles();
  const history = useHistory();
  const termsLink = useSelector(state => state.appointments.infos.terms);

  const goToSchedule = useCallback(() => {
    history.push('/appointments/new');
  }, [history]);

  const goToHistory = useCallback(() => {
    history.push('/appointments/history');
  }, [history]);

  return (
    <Box className={classes.container}>
      <Typography className="send-success-title" variant="h6">
        Pronto!
      </Typography>
      <Icon className="send-success-icon" color="inherit">
        event_available
      </Icon>
      <Typography className="send-success-message" variant="body1">
        Seu agendamento foi realizado com successo!
      </Typography>
      <Box component="ul" className="send-success-list-infos-container">
        <Box component="li" className="send-success-list-infos-item-container">
          <Icon className="send-success-list-infos-item-icon">
            check_circle
          </Icon>
          <Typography
            variant="body2"
            className="send-success-list-infos-item-text"
          >
            Fique atento ao seu email. Qualquer novidade você será notificado
            por lá.
          </Typography>
        </Box>
        <Box component="li" className="send-success-list-infos-item-container">
          <Icon className="send-success-list-infos-item-icon">
            check_circle
          </Icon>
          <Typography
            variant="body2"
            className="send-success-list-infos-item-text"
          >
            Não perca seu horário. Caso deseje cancelar o agendamento, informe
            com no mínimo 48h de antecedência ou perderá seu agendamento.
          </Typography>
        </Box>
        <Box component="li" className="send-success-list-infos-item-container">
          <Icon className="send-success-list-infos-item-icon">
            check_circle
          </Icon>
          <Typography
            variant="body2"
            className="send-success-list-infos-item-text"
          >
            {'Para mais informações, leia nossos '}
            <Link
              href={termsLink}
              target="_blank"
              color="inherit"
              underline="always"
            >
              Termos e Condições
            </Link>
          </Typography>
        </Box>
      </Box>
      <Button
        variant="contained"
        color="primary"
        className="send-success-button-history"
        onClick={goToHistory}
      >
        Ver meus agendamentos
      </Button>
      <Button
        color="secondary"
        className="send-success-button-new"
        onClick={goToSchedule}
      >
        Novo agendamento
      </Button>
    </Box>
  );
};

export default SendSuccess;
